import gql from 'graphql-tag';

const GET_MEMBERSHIP_TOTALS = gql`
  fragment membershipTotal on MembershipTotal {
    membershipCount
    membershipLessThan100DollarCount
    membershipGreaterThan100DollarCount
    membershipRevenue
    cashbackAmount
    campaignFeeAmount
    marketingFeeAmount
  }

  query getMerchantMembershipTotals($params: ReportInput!) {
    merchantMembershipTotals(params: $params) {
      totals {
        ...membershipTotal
      }

      online {
        ...membershipTotal
      }

      inStore {
        ...membershipTotal
      }
    }
  }
`;

export default GET_MEMBERSHIP_TOTALS;
